import React, { ReactNode, RefObject } from 'react'
import classNames from 'classnames'
// import format from 'date-fns/format'
import { Message } from '~/service/chatConn/types'
import Tooltip from '~/components/common/Tooltip'
import { formatDate } from '~/utils/dateFns'

type MessageProps = {
  children: ReactNode
  message: Message
  className?: string
  style?: object
  animationClassName: string
  _ref?: RefObject<HTMLDivElement>
}

export const MessageWrapper: React.FC<MessageProps> = ({
  children,
  className = '',
  style = {},
  message,
  animationClassName,
  _ref,
}) => {
  const { uid, type } = message

  const inner = (
    <div
      className={classNames('chat-message', className, animationClassName)}
      style={style}
      data-uid={uid}
      ref={_ref}
    >
      {children}
    </div>
  )

  return ['AI', 'CLIENT', 'USER', 'REDIRECT'].includes(type) ? (
    <Tooltip content={formatDate(message.sentAt, 'p')} delay={[1000, 0]}>
      {inner}
    </Tooltip>
  ) : (
    inner
  )
}
